"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var ActivityModel = /** @class */ (function () {
    function ActivityModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/activity",
        };
        this.extract = this.extract.bind(this);
        this.cacheResponse = this.cacheResponse.bind(this);
    }
    ActivityModel.prototype.extract = function (result) {
        return result.data;
    };
    ActivityModel.prototype.cacheResponse = function (result) {
        return this.extract(result);
    };
    ActivityModel.prototype.getActivity = function (params) {
        return this.$http
            .get(this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(params))
            .then(this.cacheResponse);
    };
    ActivityModel.prototype.getStudentActivity = function (studentId, params) {
        return this.$http
            .get(this.APPURL +
            "/api/v1/users/students/" +
            studentId +
            "/activity?" +
            (0, queryString_1.toQueryString)(params))
            .then(this.cacheResponse);
    };
    return ActivityModel;
}());
ActivityModel.$inject = ["$http", "APPURL"];
exports.default = ActivityModel;
